export default __webpack_public_path__ + "locales/tr/Ldap.json?hash=461b66438b32b977eb029f8571284620";